import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import { useMedia } from "../../contexts/MediaContext";
import pacienteVideo from "../../assets/avatares/paciente-1.webm";
import pacienteVideoMp4 from "../../assets/avatares/paciente-1.mp4";
import flechaAvanzar from "../../assets/right-arrow.svg";
import { modalPresentacionManuel } from "../../utils/logger";
import ScenarioBar from "../../components/ScenarioBar";
import Scenario2NextCta from "./Scenario2NextCta";
import "../StartGame.css";
import "./Scenario2.css";

const PACIENTE_MODAL_HTML =
	"Estoy muy cansado, he perdido peso y he visto sangre en las heces. Me preocupa que sea algo serio.";

const CHECKLIST = [
	"Estado general: consciente, orientado y colaborador. ECOG 1. Sin adenopatías cervicales palpables.",
	"Constantes: TA 138/82 mmHg, FC 86 lpm, SatO₂ 97 % basal, afebril (36,5 °C). Peso 78 kg (habitual 84 kg), talla 1,73 m, IMC 26,1 kg/m².",
	"Cabeza y cuello: mucosas levemente pálidas. Cardiopulmonar: tonos rítmicos, sin soplos; murmullo vesicular conservado.",
	"Abdomen blando y depresible: leve molestia a la palpación profunda en hemiabdomen izquierdo, sin irritación peritoneal ni masas claras. Sin ascitis clínica.",
	"Tacto rectal: ampolla sin masa palpable; restos fecales sin sangre franca. Extremidades sin edemas. Neurológico sin focalidad.",
];

function Scenario2Context2() {
	const location = useLocation();
	const { unlockAllMedia } = useMedia();
	const activeScenario = getScenarioNumByPath(location.pathname);
	const [patientVideoCompleted, setPatientVideoCompleted] = useState(false);

	const abrirVideoPaciente = async () => {
		await unlockAllMedia();
		modalPresentacionManuel(
			PACIENTE_MODAL_HTML,
			pacienteVideo,
			pacienteVideoMp4,
			() => setPatientVideoCompleted(true),
			flechaAvanzar,
			true,
			0.85,
			"blue",
			false,
			"modal-video-container--sg5-sc2"
		);
	};

	return (
		<div className="start-game-page sc2-context-page">
			<div className="start-game-inner start-game-inner--prep5">
				<span className="start-game-badge sg5-badge">
					<span className="start-game-badge-dot" aria-hidden />
					Escenario 2 · Diagnóstico
				</span>

				<div className="sg5-scroll">
					<header className="sg5-hero">
						<h1 className="sg5-title">
							Exploración física en <span className="sg5-title-accent">consulta</span>
						</h1>
					</header>

					<div className="sc2-c2-body sc2-c2-aside-stack">
						<div className="sg5-aside-card">
							<h2 className="sg5-aside-title">Hallazgos por aparatos</h2>
							<ul className="sg5-checklist sc2-c2-checklist-wide">
								{CHECKLIST.map((text) => (
									<li key={text}>
										<span className="sg5-check-ico" aria-hidden>
											✓
										</span>
										<span>{text}</span>
									</li>
								))}
							</ul>
						</div>

						<div className="sg5-aside-card sg5-aside-card--accent">
							<p className="sc2-c2-video-lead">
								Reflexión breve del paciente sobre cómo se encuentra en este momento del proceso.
							</p>
							<button
								type="button"
								className="start-game-cta sc2-c2-patient-cta"
								onClick={abrirVideoPaciente}
							>
								Abrir vídeo del paciente
							</button>
						</div>
					</div>
				</div>

				<div className="sg5-actions">
					<Scenario2NextCta
						navigateTo={ROUTES.SCENARIO2_CONTEXT3}
						activeScenario={activeScenario}
						canContinue={patientVideoCompleted}
						lockedTitle="Completad primero el vídeo del paciente en el reproductor"
					/>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}

export default Scenario2Context2;
